import { intersection } from 'lodash-es';

export const filterIndexes = (validLabelProps, indexes) => {
  if (!validLabelProps || !indexes) {
    return [];
  }

  return indexes.reduce((filteredIndexes, index) => {
    if (validLabelProps[index.label]) {
      const filteredProps = intersection(
        index.propertyKeys,
        validLabelProps[index.label].map((labelProp) => labelProp.propertyKey),
      );
      if (filteredProps.length > 0) {
        filteredIndexes.push({
          label: index.label,
          propertyKeys: filteredProps,
        });
      }
    }
    return filteredIndexes;
  }, []);
};
